




























































import {Vue, Component} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from '@/services/data-proxy.service'
import {formatDate, formatInteger, formatPrice} from "@/utils/formatters";
import {StavkaIzvestajaSipanjaIPotrosnjeGoriva} from "@/services/BackendProxies";
import moment from "moment";
import * as _ from 'lodash'

@Component
export default class IzvestajSipanjaGoriva extends mixins(ComponentBaseMixin) {
    odDatuma = moment().startOf('month').toDate();
    doDatuma = moment().endOf('month').toDate();
    grupaVozila = null;
    vozilo = null;
    grupeVozila = [];
    filterVisible = false;
    postavljenFilter = true;
    isBusy = false;
    izvestaj: Array<StavkaIzvestajaSipanjaIPotrosnjeGoriva> = [];
    columns = [];
    options = {
        pagination: true,
        headerStyle: () => {
            return {css: {'font-size': '10px'}}
        },
        footerStyle: () => {
            return {css: {'font-weight': 'bold'}}
        },
        showColumns: true,
        showFooter: true,
        showExport: true,
        exportTypes: ['excel'],
        exportDataType: 'all',
    };

    stavka: StavkaIzvestajaSipanjaIPotrosnjeGoriva = new StavkaIzvestajaSipanjaIPotrosnjeGoriva();
    dijalogOtvoren = false;
    edit: StavkaIzvestajaSipanjaIPotrosnjeGoriva;

    async created() {
        this.columns = [
            {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate, width: 100, sortable: true},
            {field: 'vozilo', title: this.$i18n.t('vozilo'), width: 100, sortable: true,
                formatter: (vozilo, row) => `<a href='/#/detalji-vozila/${row.voziloId}'>${vozilo}</a>`},
            {field: 'gorivo', title: this.$i18n.t('gorivo'), width: 80, sortable: true},
            {
                field: 'stanjeKilometrazePriSipanju', title: this.$i18n.t('stanjeKilometrazePriSipanju'),
                formatter: formatInteger, width: 120, align: 'right',
                footerFormatter: this.$i18n.t('total'),
                sortable: true
            },
            {
                field: 'predjenoKilometaraNakonPrethodnogSipanja',
                title: this.$i18n.t('predjenoKilometaraNakonPrethodnogSipanja'), formatter: formatInteger,
                width: 120, align: 'right',
                footerFormatter: items => formatPrice(_.sumBy(items, 'predjenoKilometaraNakonPrethodnogSipanja')),
                sortable: true
            },
            {
                field: 'sipanaKolicina',
                title: this.$i18n.t('sipanaKolicina'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                footerFormatter: items => formatPrice(_.sumBy(items, 'sipanaKolicina')),
                sortable: true
            },
            {
                field: 'vrednostSipanogGoriva',
                title: this.$i18n.t('vrednostSipanogGoriva'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                footerFormatter: items => formatPrice(_.sumBy(items, 'vrednostSipanogGoriva')),
                sortable: true
            },
            {
                field: 'prosecnaPotrosnjaGoriva',
                title: this.$i18n.t('prosecnaPotrosnjaGoriva'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                footerFormatter: items => {
                    const predjenoKm = _.sumBy(items, 'predjenoKilometaraNakonPrethodnogSipanja');
                    const sipano = _.sumBy(items, 'sipanaKolicina');
                    return formatPrice(predjenoKm ? sipano * 100 / predjenoKm : 0);
                },
                sortable: true
            },
            {
                field: 'normiranaPotrosnja',
                title: this.$i18n.t('normiranaPotrosnja'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                sortable: true
            },
            {
                field: 'prekoracenjeNorme',
                title: this.$i18n.t('prekoracenjeNorme'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                sortable: true
            },
            {
                field: 'prekoracenjeULitrama',
                title: this.$i18n.t('prekoracenjeULitrama'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                footerFormatter: items => formatPrice(_.sumBy(items, 'prekoracenjeULitrama')),
                sortable: true
            },
            {
                field: 'prekoracenjeUVrednosti',
                title: this.$i18n.t('prekoracenjeUVrednosti'),
                formatter: formatPrice,
                width: 120,
                align: 'right',
                footerFormatter: items => formatPrice(_.sumBy(items, 'prekoracenjeUVrednosti')),
                sortable: true
            },
        ];
      this.grupeVozila = await dataProxy.vratiGrupeVozila();
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    async pretrazi() {
        if (this.isBusy) return;
        this.isBusy = true;
        try {
            this.izvestaj = await this.loadData(() => dataProxy.vratiIzvesteajEvidencijeSipanjaIPotrosnjeGoriva(this.odDatuma, this.doDatuma, this.grupaVozila, this.vozilo))();
        } finally {
            this.isBusy = false;
        }
    }

    rowClick(row) {
        this.stavka = StavkaIzvestajaSipanjaIPotrosnjeGoriva.fromJS(row);
        this.edit = row;
        this.dijalogOtvoren = true;
    }

    sacuvajNovuKilometrazu() {
        this.edit.stanjeKilometrazePriSipanju = this.stavka.stanjeKilometrazePriSipanju;
        this.saveData(() => dataProxy.sacuvajStavkuSipanjaGoriva(this.edit))();
        this.dijalogOtvoren = false;
    }
}
